export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 21 17" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100众筹" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="WEB-/--Bundles-tab" transform="translate(-1312.000000, -789.000000)" stroke="#666666" strokeWidth="1.62">
                    <g id="-mockplus-" transform="translate(0.000000, 60.000000)">
                        <g id="编组-3" transform="translate(1213.000000, 729.914012)">
                            <g id="编组-2" transform="translate(99.000000, 0.000000)">
                                <path
                                    d="M18.3,0.81 C18.7404562,0.81 19.1456477,0.960707186 19.4669977,1.21326857 L19.4669977,1.21326857 L11.9463968,8.72975148 C11.5768009,9.09844126 11.0927699,9.28275468 10.6087551,9.28275442 C10.1247402,9.28275417 9.64070946,9.09844023 9.27169953,8.73033481 L9.27169953,8.73033481 L1.65995799,1.12170735 C1.95829112,0.92472037 2.31572559,0.81 2.7,0.81 L2.7,0.81 Z"
                                    id="形状结合"
                                ></path>
                                <rect id="矩形" x="0.81" y="0.81" width="19.38" height="14.4723483" rx="2.7"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
